import React from 'react'

const WorkRoleActive1 = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 6.71921C3.10381 6.38596 3.24655 6.08382 3.5277 5.87498C3.60555 5.81722 3.95591 5.63949 4.03376 5.63949H8.1299V3.56002C8.1299 3.34674 8.44565 2.99128 8.67489 3.00016L15.4614 3.03571C15.6301 3.08459 15.8637 3.39117 15.8637 3.56002V5.63504H19.9598C20.4096 5.63504 21.0411 6.40374 20.9979 6.87917V17.6453C20.92 18.2318 20.4745 18.7472 19.8906 18.8228H4.07269C3.51905 18.725 3.14274 18.2763 3 17.7386V6.71921ZM14.5661 4.30205H9.43183V5.63949H14.5661V4.30205Z" fill="#3A4BDA"/>
    </svg>
  )
}

export default WorkRoleActive1
